export const getAuthToken = () => {
    if (localStorage.getItem('admin_token')) {
        return localStorage.getItem('admin_token')
    }
    return '';
}

export const setAuthToken = (token) => {
    if(token){
        localStorage.setItem("admin_token", token);
    }
}

export const setWalletAddress = (token) => {
    if(token){
        localStorage.setItem("userWalletAddress", token);
    }
}

export const getWalletAddress = () => {
    if (sessionStorage.getItem('accountInfo')) {
      return sessionStorage.getItem('accountInfo')
    }
    return '';
  }